var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 9V1",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8902 4C24.2207 8.19308 23.507 14.3594 19.4629 17.8125C15.4187 21.2656 9.47147 20.5257 6.14101 16.3326C3.28633 12.6328 3.28633 7.69977 6.14101 4",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeco);
export default __webpack_public_path__ + "static/media/DECO.b75d5fb4b0bb8488fe34ad6813e14b9d.svg";
export { ForwardRef as ReactComponent };